import React from 'react';
import { Link } from 'react-router-dom';
import aiOrderManagement from '../assets/ai-order-management.jpg';
import inventoryOptimization from '../assets/inventory-optimization.jpg';
import analyticsDashboard from '../assets/analytics-dashboard.jpg';

const Products = () => {
    return (
        <div className="p-8 text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Our AI-Powered Solutions</h1>
            <p className="text-lg text-gray-600 mb-8">
                Transform your restaurant and bakery operations with our advanced AI solutions, designed to boost efficiency and maximize profitability.
            </p>

            {/* Products Grid */}
            <div className="grid md:grid-cols-3 gap-8">
                {/* Product 1: AI Order Management */}
                <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition duration-300">
                    <img src={aiOrderManagement} alt="AI Order Management" className="w-full h-48 object-cover rounded-t-lg" />
                    <div className="p-4">
                        <h2 className="text-2xl font-semibold text-gray-800">AI Order Management</h2>
                        <p className="text-gray-600 mt-2">
                            Streamline order processing, prevent missed orders, and improve delivery coordination with our intelligent order management system.
                        </p>
                        <Link to="/order-entry" className="block bg-blue-500 text-white px-4 py-2 rounded mt-4 hover:bg-blue-600">
                            Learn More
                        </Link>
                    </div>
                </div>

                {/* Product 2: Inventory Optimization */}
                <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition duration-300">
                    <img src={inventoryOptimization} alt="Inventory Optimization" className="w-full h-48 object-cover rounded-t-lg" />
                    <div className="p-4">
                        <h2 className="text-2xl font-semibold text-gray-800">Inventory Optimization</h2>
                        <p className="text-gray-600 mt-2">
                            Reduce food wastage and manage inventory efficiently with AI-powered predictions and automated inventory tracking.
                        </p>
                        <Link to="/order-entry" className="block bg-blue-500 text-white px-4 py-2 rounded mt-4 hover:bg-blue-600">
                            Learn More
                        </Link>
                    </div>
                </div>

                {/* Product 3: Real-Time Analytics Dashboard */}
                <div className="bg-white rounded-lg shadow-md hover:shadow-lg transition duration-300">
                    <img src={analyticsDashboard} alt="Real-Time Analytics" className="w-full h-48 object-cover rounded-t-lg" />
                    <div className="p-4">
                        <h2 className="text-2xl font-semibold text-gray-800">Real-Time Analytics</h2>
                        <p className="text-gray-600 mt-2">
                            Make informed decisions with real-time insights into sales, inventory levels, and customer preferences.
                        </p>
                        <Link to="/order-entry" className="block bg-blue-500 text-white px-4 py-2 rounded mt-4 hover:bg-blue-600">
                            Learn More
                        </Link>
                    </div>
                </div>
            </div>

            {/* Call-to-Action Section */}
            <div className="mt-12">
                <h2 className="text-2xl font-semibold text-gray-800">Ready to Get Started?</h2>
                <p className="text-lg text-gray-600 mt-2">
                    Discover how NinjaBakers can revolutionize your business operations with AI-driven efficiency.
                </p>
                <Link to="/order-entry" className="bg-green-500 text-white px-6 py-3 rounded-md text-lg hover:bg-green-600 mt-4 inline-block">
                    Place an Order Now
                </Link>
            </div>
        </div>
    );
};

export default Products;
